<script>
    import Section from "../controls/Section.svelte";
    import GameListing from "../views/GameListing.svelte";
    import { getAllGames } from "../stores/GameStore.js";
    import { Sections } from "../../lib/nav";

    let allGames = getAllGames();

    export let onGameSelected = (section, params = {}) => {};

</script>

<div class="space-y-8 text-left">
    <Section title="Add Game" subtitle="Choose the Game you want to add from the list below. You can add multiple games and even have multiple of the same game set up.">
        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mt-4">
        {#each allGames.slice().sort((a, b) => b.isLive - a.isLive) as game (game.id)}
            <GameListing game={game} onNavigate={() => onGameSelected(Sections.GAMES_ADD_NEW_DETAILS, {selectedGameId: game.id})} />
        {/each}
        </div>
    </Section>
</div>
